import api from '../index.js'

export default {
  getCompanies(type, pageNum, pageSize) {
    const num = pageNum == null ? 1 : pageNum
    const size = pageSize == null ? 20 : pageSize
    if (type == 'admin') {
      return api.get(`/v2/admins/companies?page=${num}&page_size=${size}`)
    } else if (type == 'distributor') {
      return api.get(`/v2/distributors/companies?page=${num}&page_size=${size}`)
    }
  },
  getCompany(type, id) {
    if (type == 'admin') {
      return api.get(`/v2/admins/companies/${id}`)
    } else if (type == 'distributor') {
      return api.get(`/v2/distributors/companies/${id}`)
    }
  }
}
